import httpRepo from '@/core/httpRepo'

export default httpRepo('api_token');
